/*! Hot Tub Konfigurator – compact embedded version (A-Flat, 120px) (c) 2025 */
(function(){
  const mount = document.getElementById('hot-tub-konfigurator');
  if(!mount){ console.warn('[Konfigurator] Container #hot-tub-konfigurator nicht gefunden.'); return; }

  function deriveAccent() {
    try {
      const btn = document.querySelector('button, .button, .btn, [type=submit]');
      if (btn) {
        const bg = getComputedStyle(btn).backgroundColor;
        if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return bg;
        const col = getComputedStyle(btn).color;
        if (col) return col;
      }
      const a = document.createElement('a'); a.style.display='none'; document.body.appendChild(a);
      const col = getComputedStyle(a).color; a.remove();
      return col || '#0046ff';
    } catch(e){ return '#0046ff'; }
  }
  const ACCENT = deriveAccent();

  const css = `
  .htk *{box-sizing:border-box}
  .htk{font-family:inherit;color:inherit;background:transparent}
  .htk .wrap{max-width:980px;margin:0 auto;padding:16px}
  .htk .hd{text-align:center;margin:0 0 8px}
  .htk .hd h1{font-size:1.35rem;line-height:1.3;margin:0 0 4px;font-weight:700}
  .htk .hd p{font-size:.95rem;color:rgba(0,0,0,.65);margin:0}
  .htk .pb{height:3px;background:rgba(0,0,0,.08);border-radius:3px;margin:10px auto 14px;overflow:hidden;max-width:420px}
  .htk .pf{height:100%;width:0;background:${ACCENT};transition:width .25s ease;border-radius:3px}
  .htk .pt{font-size:.85rem;color:rgba(0,0,0,.55);text-align:center;margin-bottom:12px}
  .htk .card{background:rgba(0,0,0,.02);border:1px solid rgba(0,0,0,.06);border-radius:4px;padding:14px}
  .htk .step{display:none}
  .htk .step.active{display:block}
  .htk h3{font-size:1.06rem;line-height:1.35;margin:2px 0 10px;text-align:center}
  .htk .opts{display:grid;grid-template-columns:repeat(auto-fit,minmax(120px,1fr));gap:10px;margin-bottom:8px}
  .htk .opt{border:1px solid rgba(0,0,0,.16);background:#fff;border-radius:4px;padding:10px;cursor:pointer;text-align:center;transition:transform .1s ease,border-color .12s ease, background-color .12s ease}
  .htk .opt:hover{border-color:${ACCENT};background:rgba(0,0,0,.02);transform:translateY(-1px)}
  .htk .opt.sel{border-color:${ACCENT};background:rgba(0,0,0,.02)}
  .htk .opt .lbl{font-weight:700;font-size:.95rem}
  .htk .opt img{width:100%;height:120px;object-fit:cover;border-radius:3px;margin:0 0 8px;display:block}
  .htk .nav{display:flex;gap:8px;max-width:400px;margin:8px auto 0}
  .htk .btn{flex:1;display:inline-flex;align-items:center;justify-content:center;border:1px solid rgba(0,0,0,.2);background:#fff;border-radius:3px;padding:8px 12px;font-weight:700;font-size:.95rem;cursor:pointer;user-select:none;transition:background-color .12s ease,border-color .12s ease}
  .htk .btn:hover{border-color:${ACCENT};background:rgba(0,0,0,.02)}
  .htk .btn[disabled]{opacity:.45;cursor:not-allowed}
  .htk .btn.next{color:inherit}
  .htk .res{display:none;background:rgba(0,0,0,.02);border:1px solid rgba(0,0,0,.06);border-radius:4px;padding:14px;margin-top:10px}
  .htk .res.show{display:block}
  .htk .res h2{font-size:1.15rem;text-align:center;margin:0 0 8px}
  .htk .intro{font-size:.95rem;color:rgba(0,0,0,.65);text-align:center;margin:0 0 12px}
  .htk .sum{background:#fff;border:1px solid rgba(0,0,0,.08);border-radius:4px;padding:10px;max-width:520px;margin:0 auto 12px}
  .htk .sum .row{display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px dashed rgba(0,0,0,.08)}
  .htk .sum .row:last-child{border-bottom:0}
  .htk .sum .k{font-weight:600;color:rgba(0,0,0,.6)}
  .htk .sum .v{font-weight:800;color:${ACCENT}}
  .htk .load{padding:20px 10px;text-align:center;color:rgba(0,0,0,.6)}
  .htk .spin{width:34px;height:34px;border:3px solid rgba(0,0,0,.12);border-top-color:${ACCENT};border-radius:50%;margin:0 auto 10px;animation:htkspin 1s linear infinite}
  @keyframes htkspin{to{transform:rotate(360deg)}}
  .htk .np{background:#fff7e6;border:1px solid #ffe0a3;border-radius:4px;padding:10px;text-align:center}
  .htk .lnk{display:inline-block;background:${ACCENT};color:#fff;text-decoration:none;padding:9px 14px;border-radius:3px;font-weight:800}
  .htk .grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,1fr));gap:14px}
  @media (max-width: 768px){
    .htk .wrap{padding:10px}
    .htk .opt img{height:120px}
    .htk .nav{flex-direction:column}
  }`;

  const html = `
    <div class="htk" role="region" aria-label="Hot Tub Konfigurator">
      <div class="wrap">
        <div class="hd">
          <h2>Finden Sie Ihren Wohlfühl-Hot&nbsp;Tub</h2>
          <p>In 3 kurzen Schritten zu Ihrer perfekten Auszeit zu Hause</p>
        </div>
        <div class="pb" aria-hidden="true"><div class="pf" id="pf"></div></div>
        <div class="pt" id="pt">Schritt 1 von 3</div>
        <div class="card" id="card">
          <div class="step active" data-step="1">
            <h3>Wie viele Personen sollen im Hot Tub entspannen?</h3>
            <div class="opts">
              <div class="opt" data-filter="persons" data-value="2 Personen"><div class="lbl">2 Personen</div></div>
              <div class="opt" data-filter="persons" data-value="4 Personen"><div class="lbl">4 Personen</div></div>
              <div class="opt" data-filter="persons" data-value="6 Personen"><div class="lbl">6 Personen</div></div>
              <div class="opt" data-filter="persons" data-value="8 Personen"><div class="lbl">8 Personen</div></div>
            </div>
            <div class="nav"><button class="btn next" id="n1" disabled>Weiter →</button></div>
          </div>
          <div class="step" data-step="2">
            <h3>Welche Form passt besser zu Ihrem Gartenstil?</h3>
            <div class="opts">
              <div class="opt" data-filter="shape" data-value="Runder Hot Tub">
                <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0730/0307/3877/files/Hot_Tub_rund.jpg" alt="Runder Hot Tub"><div class="lbl">Rund</div>
              </div>
              <div class="opt" data-filter="shape" data-value="Quadratischer Hot Tub">
                <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0730/0307/3877/files/Hot_Tub_eckig.jpg" alt="Quadratischer Hot Tub"><div class="lbl">Quadratisch</div>
              </div>
            </div>
            <div class="nav">
              <button class="btn" id="b2">← Zurück</button>
              <button class="btn next" id="n2" disabled>Weiter →</button>
            </div>
          </div>
          <div class="step" data-step="3">
            <h3>Mit welchem Ofentyp möchten Sie das Wasser am liebsten heizen?</h3>
            <div class="opts">
              <div class="opt" data-filter="heater" data-value="Integrierter Ofen">
                <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0730/0307/3877/files/integrierter_Ofen.jpg" alt="Integrierter Ofen"><div class="lbl">Integrierter Ofen (weniger Platz in der Wanne, dafür besser von Hot Tub Struktur geschützt)</div>
              </div>
              <div class="opt" data-filter="heater" data-value="horizontaler Ofen">
                <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0730/0307/3877/files/horizontaler_Ofen.jpg" alt="Horizontaler Ofen"><div class="lbl">Horizontaler Ofen (viel Platz in der Wanne und von Hot Tub Struktur geschützt)</div>
              </div>
              <div class="opt" data-filter="heater" data-value="Außenofen">
                <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0730/0307/3877/files/Aussenofen_f09956be-6d26-4342-9bf9-3b52ae545788.jpg" alt="Außenofen"><div class="lbl">Außenofen (viel Platz in der Wanne, dafür nicht von Hot Tub Struktur geschützt)</div>
              </div>
            </div>
            <div class="nav"><button class="btn" id="b3">← Zurück</button></div>
          </div>
        </div>
        <div class="res" id="res">
          <h2>Ihre persönliche Auswahl</h2>
          <p class="intro">Auf Basis Ihrer Wünsche – entdecken Sie jetzt passende Modelle:</p>
          <div class="sum">
            <div class="row"><span class="k">Personen:</span><span class="v" id="sumP">-</span></div>
            <div class="row"><span class="k">Form:</span><span class="v" id="sumS">-</span></div>
            <div class="row"><span class="k">Holzofen:</span><span class="v" id="sumH">-</span></div>
          </div>
          <div class="load" id="load" style="display:none"><div class="spin"></div><div>Produkte werden geladen …</div></div>
          <div id="grid"></div>
        </div>
      </div>
    </div>
  `;

  const style = document.createElement('style'); style.textContent = css;
  mount.innerHTML = html;
  mount.prepend(style);

  let step = 1; const total = 3;
  const cfg = {persons:null, shape:null, heater:null};
  const $ = s => mount.querySelector(s);
  const $$ = s => mount.querySelectorAll(s);

  function progress() {
    $('#pf').style.width = (step/total*100)+'%';
    $('#pt').textContent = `Schritt ${step} von ${total}`;
  }
  function show(n){
    $$('.step').forEach(el=>el.classList.remove('active'));
    const t = mount.querySelector(`.step[data-step="${n}"]`);
    if(t){ t.classList.add('active'); step = n; progress(); }
  }
  progress();

  mount.addEventListener('click', function(ev){
    const opt = ev.target.closest('.opt');
    if(opt){
      const f = opt.getAttribute('data-filter');
      const v = opt.getAttribute('data-value');
      $$('.opt[data-filter="'+f+'"]').forEach(o=>o.classList.remove('sel'));
      opt.classList.add('sel');
      cfg[f] = v;
      const st = opt.closest('.step').getAttribute('data-step');
      const next = $('#n'+st);
      if(next) next.removeAttribute('disabled');
      window.setTimeout(()=>{ if(st === '3'){ showResults(); } else if(next){ next.click(); } }, 100);
      return;
    }
    if(ev.target.id === 'n1'){ show(2); }
    if(ev.target.id === 'b2'){ show(1); }
    if(ev.target.id === 'n2'){ show(3); }
    if(ev.target.id === 'b3'){ show(2); }
  });

  function buildURL(){
    const base='https://wellnessfuerdraussen.de/collections/hot-tub';
    const qs = [
      'filter.p.m.custom.personenzahl='+encodeURIComponent(cfg.persons||''),
      'filter.p.m.custom.hot_tub_form='+encodeURIComponent(cfg.shape||''),
      'filter.p.m.custom.hot_tub_ofen='+encodeURIComponent(cfg.heater||'')
    ].join('&');
    return base+'?'+qs;
  }

  async function showResults(){
    $('#sumP').textContent = cfg.persons||'-';
    $('#sumS').textContent = cfg.shape||'-';
    $('#sumH').textContent = cfg.heater||'-';
    $('#card').style.display='none'; $('.pb').style.display='none'; $('.pt').style.display='none';
    $('#res').classList.add('show');
    $('#load').style.display='block';
    const url = buildURL();
    try{
      const r = await fetch(url+'&view=json',{credentials:'omit'});
      const t = await r.text();
      const doc = new DOMParser().parseFromString(t,'text/html');
      const grid = doc.querySelector('.collection, [data-collection], .product-grid');
      $('#load').style.display='none';
      if(grid && grid.innerHTML.trim()){
        $('#grid').innerHTML = '<div class="grid">'+grid.innerHTML+'</div>';
        $('#grid').querySelectorAll('img').forEach(img=>{img.loading='lazy'});
      }else{
        $('#grid').innerHTML = `<div class="np"><h3>Perfekte Auswahl getroffen!</h3><p>Wir zeigen Ihnen jetzt alle passenden Hot Tubs im Shop.</p><a class="lnk" href="${url}&quizresult=yes">Zu Ihren Hot Tubs →</a></div>`;
      }
    }catch(e){
      console.error('[Konfigurator] Laden fehlgeschlagen', e);
      $('#load').style.display='none';
      $('#grid').innerHTML = `<div class="np"><h3>Perfekte Auswahl getroffen!</h3><p>Wir zeigen Ihnen jetzt alle passenden Hot Tubs im Shop.</p><a class="lnk" href="${url}&quizresult=yes">Zu Ihren Hot Tubs →</a></div>`;
    }
  }
// === Calendly-Primary-Button bei ?quizresult=yes (Focal mit .product-list__inner) ===
(function calendlyCTAForFocal(){
  if (!window.location.search.includes('quizresult=yes')) return;

  // HTML des Buttons
  const CTA_HTML = `
    <div class="calendly-cta-under-grid" style="margin:24px 0 32px;text-align:center;">
      <p>
        <a class="button button--primary"
           href="https://calendly.com/jens-ischebeck/hot-tub-beratung"
           target="_blank" rel="noopener noreferrer">
           ➡️ Wenn Sie jetzt ihre Beratung buchen, dann sprudelt der Hot Tub schon in 2 Monaten in Ihrem Garten.
        </a>
      </p>
    </div>
  `;

  // Focal-spezifische Selektoren (inkl. deinem .product-list__inner)
  const SELECTORS = [
    '.product-list__inner',
    '#product-grid',
    '.collection__products',
    '.collection__grid'
  ];

  function findGrid(){
    for (const sel of SELECTORS){
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function insertCTA(){
    if (document.querySelector('.calendly-cta-under-grid')) return; // kein doppelter Button
    const grid = findGrid();
    if (!grid) return;
    grid.insertAdjacentHTML('afterend', CTA_HTML);
  }

  // 1️⃣ Sofort versuchen
  insertCTA();

  // 2️⃣ Nach DOM-Load (falls Grid später erscheint)
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', insertCTA);
  } else {
    setTimeout(insertCTA, 150);
  }

  // 3️⃣ Beobachten: falls Focal das Grid per AJAX neu rendert
  const obs = new MutationObserver(() => {
    if (!document.querySelector('.calendly-cta-under-grid')){
      insertCTA();
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // 4️⃣ Sicherheit: ein paar Retries nach kurzer Zeit
  [400, 1200, 2000].forEach(ms => setTimeout(insertCTA, ms));
})();
// === Optimierung für Ergebnisseite mit ?quizresult=yes ===
(function handleQuizResultPage(){
  if (!window.location.search.includes('quizresult=yes')) return;

  // 🔹 1. Hot Tub Konfigurator komplett entfernen
  const configurator = document.getElementById('hot-tub-konfigurator');
  if (configurator) configurator.remove();

  // 🔹 2. H2-Überschrift oberhalb des Produkt-Grids einfügen
  const grid = document.querySelector('.product-list__inner');
  if (grid && !document.querySelector('.quizresult-heading')) {
    const heading = document.createElement('h2');
    heading.textContent = 'Ihre Hot Tub Auswahl:';
    heading.className = 'quizresult-heading';
    heading.style.margin = '24px 0 16px';
    heading.style.textAlign = 'center';
    grid.insertAdjacentElement('beforebegin', heading);
  }
})();

})();

